<template>
	<!-- 顶部图片、滚动 -->
	<div class="top-pageview">
		<el-carousel :interval="2000" height="360px" v-if="carouselDatas[0]!=null">
			<el-carousel-item v-for="item,index in carouselDatas" @click.native="onCarouselClick(item)" :key="index"
				style="display:flex; align-items: flex-start; justify-content: center;cursor: pointer;">
				<img :src="item.pic"/>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	import hsimage from './hsimage.vue'

	export default {
		name: 'BannerTop',
		components: {
			hsimage
		},
		data() {
			return {
				carouselDatas: []
			}
		},
		mounted() {
			this.getCarouselList()
		},
		methods: {

			getCarouselList() {
				this.$request.get('/content/listCarousel', {}, false).then(
					response => {
						// console.log('轮播数据',response)
						if (response.data.code == 200) {
							this.carouselDatas = response.data.rows
							// this.carouselDatas.forEach(e=>{
							// 	e.pic='https://hansvision.com'+e.pic
							// })
						} else {
							this.carouselDatas = []
						}
					}
				).catch(err => {
					console.log(err)
					this.carouselDatas = []
				})
			},
			onCarouselClick(val) {
				let url = val.url
				let link = val.outlink
				if (link == '2' || url.startsWith("www") || url.startsWith("http")) {
					window.open("https://" + url, '_blank')
				} else {
					this.$router.push({
						name: url
					})
				}
			},
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/banner_top.vue